export default {
  privige: {
    credits: "AI积分",
    agent: "应用",
    knowledgeBaseCapacity: "知识库文件容量",
    databaseDataNum: "内置数据库行数",
    remoteDatabase: "远程数据库",
    accountNumber: "账号数量",
    customPlugin: "自定义插件",
    workFlow: "工作流",
    dataDashboard: "数据看板",
    channelAccess: "渠道接入",
    clientManage: "客户端管理",
    aggregateChatManage: "聚合对话管理",
    teamSpace: "团队空间",
    basicApi: "开放 API（基础）",
    service: "服务",
    knowledgeMediaCapacity: "知识库上传的文件及素材存储容量",
    databaseDataNumDes: "内置数据库所有数据表的合计总行数",
    using: "正在使用",
    renew: "续费使用",
    start: "开始使用",
    askCustom: "立即咨询",
    discountTwoYear: "优惠两月",
    contactCustomerSupport: "联系客服",
    purchaseConsultation: "购买咨询",
    month: "按月付费",
    year: "按年付费",
    yearSelect: " /年 ",
    monthSelect: " /月 ",
    professionalAll: "专业版所有权益",
    enterpriseAll: "企业专属应用广场",
    customMember: "按需定制成员数量",
    rolePermission: "空间成员角色权限管理",
    accountStable: "账号稳定接入功能",
    customerSmart: "客户智能管理功能",
    customBrandLogo: "自定义品牌LOGO",
    privateDeployment: "可支持私有化部署",
    ownModel: "可对接自有模型",
    higherCapacity: "可提供更高的容量和并发",
    aiAgentTraining: "智能体训练调优服务",
    industrySolution: "行业解决方案赋能",
    websiteIntegration: "网站集成",
    websiteIntegrationDes: "（品牌标识定制）",
    scoreDes: "积分",
    buyNow: "立即购买",
    alreadyPrivilegeUser: "您已经是权益用户，请联系客服升级",
    dataPreparing: "数据还在准备中，请稍等片刻或刷新页面后再试",
    generatingOrder: "生成订单中~",
  },
};


